import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoLocalFaturamentoMultiselectComponent } from './novo-local-faturamento-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoLocalFaturamentoMultiselectComponent],
  exports: [NovoLocalFaturamentoMultiselectComponent]
})
export class NovoLocalFaturamentoMultiselectModule {}
